<module-container>
  <div class="title-container">
    <h2>Global Abn</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
